// extracted by mini-css-extract-plugin
export default {"item-container":"mochi-refueling-tutorial-carousel_item-container__mKhky","item-content":"mochi-refueling-tutorial-carousel_item-content__qU666"};